// extracted by mini-css-extract-plugin
module.exports = {"container":"PageError_container__2w1eb","logo":"PageError_logo__2WB8F","message":"PageError_message__141xy"};